export default {
    namespaced: true,
    bookmark: {
      title: "bookmark | bookmarks",
      categories: "bookmark categories",
    },
  };
  